export const environment = {
  production: true,
  staging: true,
  livee: {
    url: 'http://new.livee.com/app/',
    tag: 'https://iso.livee.com',
    short: 'https://eva.iso.livee.io/'
  },
  translations: {
    key: 'lang',
    baseUrl: '//translations.livee.com/api',
    default: 'french'
  },
  auth: {
    url: '//eva.iso.livee.com/auth-service',
    redirect: '//eva.iso.livee.com/login/check'
  },
  sessions: {
    url: '//eva.iso.livee.com/sessions-service',
    links: {
      vod: [],
      video: [
        {
          name: 'sessions.details.links.general',
          color: 'warning',
          values: ['moderator', 'guest', 'videoOperator', 'powerUser', 'visitor']
        }
      ],
      mixte: [
        {
          name: 'sessions.details.links.general',
          color: 'warning',
          values: ['moderator', 'guest', 'videoOperator', 'powerUser', 'visitor']
        },
        {
          name: 'sessions.details.links.wall',
          color: 'info',
          values: [
            'Wall-01-ModerationBanner',
            'Wall-02-ModerationBanner-Bubble',
            'Wall-03-AnimationBanner',
            'Wall-04-AnimationBanner-ModerationBanner',
            'Wall-05-Bubble',
            'Wall-06.1-ModerationQuestionsList',
            'Wall-08.1-TagCloud',
            'Wall-09.1-Bubble_ModerationQuestionsList',
            'Wall-Vote1-Histogram_Pie',
            'Wall-Vote3-Podium'
          ]
        },
        {
          name: 'sessions.details.links.webapp',
          color: 'danger',
          values: [
            'WebApp-D06-TagCloud',
            'WebApp-D08-Questions_MessagesDisplay',
            'WebApp-D12-VoteQuiz',
            'WebApp-S01-Home'
          ]
        }
      ],
      interactive: [
        {
          name: 'sessions.details.links.general',
          color: 'warning',
          values: ['moderator', 'guest', 'videoOperator', 'powerUser', 'visitor']
        },
        {
          name: 'sessions.details.links.wall',
          color: 'info',
          values: [
            'Wall-01-ModerationBanner',
            'Wall-02-ModerationBanner-Bubble',
            'Wall-03-AnimationBanner',
            'Wall-04-AnimationBanner-ModerationBanner',
            'Wall-05-Bubble',
            'Wall-06.1-ModerationQuestionsList',
            'Wall-08.1-TagCloud',
            'Wall-09.1-Bubble_ModerationQuestionsList',
            'Wall-10-Clapometer',
            'Wall-Vote1-Histogram_Pie',
            'Wall-Vote3-Podium'
          ]
        },
        {
          name: 'sessions.details.links.webapp',
          color: 'danger',
          values: [
            'WebApp-D06-TagCloud',
            'WebApp-D08-Questions_MessagesDisplay',
            'WebApp-D12-VoteQuiz',
            'WebApp-D14-Clapometer',
            'WebApp-S01-Home'
          ]
        }
      ]
    }
  },
  plugins: {
    url: '//eva.iso.livee.com/plugins-service'
  },
  users: {
    url: '//eva.iso.livee.com/users-service'
  },
  tags: {
    url: '//eva.iso.livee.com/tags-service'
    // url: 'http://localhost:3012'
  },
  invitations_alerts: {
    url: '//eva.iso.livee.com/invitations-alerts-api'
  },
  short: {
    url: '//eva.iso.livee.com/shortener-server'
  },
  phone: {
    url: '//eva.iso.livee.com/phone-number',
    webhook: ''
  },
  emails: {
    url: '//eva.iso.livee.com/emailsv1-service'
  },
  stats: {
    url: '//eva.iso.livee.com/stats-service'
  },
  preview: {
    url: '//eva.iso.livee.com/preview-service'
  },
  payment: {
    url: '//eva.iso.livee.com/payment-service'
  },
  google: {
    clientId: '241117617589-l34fpfd2vv66t05c42jbt6jtnavqet8b.apps.googleusercontent.com'
  },
  facebook: {
    clientId: ''
  },
  linkedin: {
    clientId: ''
  },
  screencastCustom: {
    url: '//screencast.livee.com/custom-staging'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts